import { Component, OnInit } from '@angular/core';
import { MonthlyPlanService } from '../shared/services/monthly-plan.service';
import { PortfolioService } from '@admin/portfolios/shared/services/portfolio.service';
import { MonthlyPlanReport } from '../shared/models/monthly-plan-report';
import { SelectItem } from 'primeng/api';
import { StaticValues } from '@admin/shared/static-values';
import { ConfigurationService } from '@admin/shared/services/configuration.service';
import { MonthlyPlanConfiguration } from '@admin/shared/models/configuration-models/monthly-plan-configuration';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-monthly-plan-report',
  templateUrl: './monthly-plan-report.component.html',
  styleUrls: ['./monthly-plan-report.component.less'],
  standalone: false,
})
export class MonthlyPlanReportComponent implements OnInit {
  reportData: MonthlyPlanReport;
  portfolios: number[];
  cols: any[];
  parameters: MonthlyPlanConfiguration;

  year: number;
  month: number;
  monthFilterOptions: SelectItem[];
  yearFilterOptions: SelectItem[];
  monthNames: string[];

  constructor(
    private monthlyPlanService: MonthlyPlanService,
    private portfolioService: PortfolioService,
    private translateService: TranslateService,
    private config: ConfigurationService
  ) {
    this.reportData = null;
    this.portfolios = [-1];
    this.cols = [];

    let now = new Date();
    this.year = now.getFullYear();
    this.month = now.getMonth() + 1;
  }

  onFilter() {
    this.monthlyPlanService
      .getReport(this.year, this.month)
      .subscribe((data) => {
        this.portfolios = [-1];
        this.cols = [];
        this.reportData = data;

        this.initColumns();
        this.reportData.tableData.forEach((d) => {
          d.data['isParrent'] = d.children.length > 0;
        });
      });
  }

  getCellStyleClass(valueStr: any) {
    if (!valueStr) {
      return null;
    }
    let valueNum = parseInt(valueStr);
    let classname = 'sufficient';
    if (valueNum < this.parameters.rateBound1) {
      classname = 'insufficient';
    } else if (valueNum >= this.parameters.rateBound2) {
      classname = 'surplus';
    }
    return classname;
  }

  ngOnInit() {
    let config = this.config.getCachedConfig();
    this.parameters = config.monthlyPlanParameters;
    this.initYearFilterOptions();
    this.initMonthFilterOptions();
    this.onFilter();
  }

  private initMonthFilterOptions() {
    this.monthNames = StaticValues.monthNames;
    this.monthFilterOptions = [];
    for (var i = 1; i <= 12; i++)
      this.monthFilterOptions.push({
        label: this.translateService.instant('label.' + this.monthNames[i - 1]),
        value: i,
      });
  }

  private initYearFilterOptions() {
    this.yearFilterOptions = [];
    let minYear = 2018;
    let currYear = new Date().getFullYear();
    for (var i = minYear; i <= currYear; i++)
      this.yearFilterOptions.push({ label: i.toString(), value: i });
  }

  private initColumns() {
    let data = this.reportData;

    if (
      data &&
      data.tableData &&
      data.tableData.length &&
      data.tableData.length > 0
    ) {
      let keys = Object.keys(data.tableData[0].data).filter(
        (k) => !k.includes('Sold')
      );

      this.cols.push({ field: keys[0], header: '', colored: false });
      for (let i = 1; i < keys.length; i++) {
        let key = keys[i];
        if (i % 5 == 0) {
          this.portfolios.push(+key.substring(0, key.indexOf('_')));
        } // get portfolio id from key
        if (i % 5 == 1) {
          this.cols.push({
            field: key,
            header: this.translateService.instant('label.Target'),
            colored: false,
          });
        }
        if (i % 5 == 2) {
          this.cols.push({
            field: key,
            header: this.translateService.instant('label.Total'),
            colored: false,
          });
        }
        if (i % 5 == 3) {
          this.cols.push({
            field: key,
            header: this.translateService.instant('label.Trend'),
            colored: false,
          });
        }
        if (i % 5 == 4) {
          this.cols.push({
            field: key,
            header: this.translateService.instant('label.Rate'),
            colored: true,
          });
        }
      }
    }
  }
}
